import { updateLinksAttributes } from '../utils/handleAttributes';
const wrapContainerClass = 'mainCards-wrap-container';

export default function mainCards() {
  const widgetName = 'mainCards';
  const widgetOpts = mainCardsOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createmainCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createmainCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      const $cardItem = $(this);

      $cardItem.find('.image-container').append(`
                      <span class="widget-title">${Title}</span>
`);

      validateUrl(URL, $cardItem);
      updateLinksAttributes(URL, Title, $cardItem);
    });
  }
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-url');
  }
  return url !== null;
}
